import React from 'react';

interface SearchProps {
    value: string;
   
}

const TitleCell: React.FC<SearchProps> = ({ value }) => {
    

    return (
        <div className='text-ellipsis overflow-hidden' title={`${value}`}>{value}</div>
    );
};

export default TitleCell;